import {
  faCheckCircle,
  faClock,
  faEllipsisVertical,
  faEnvelope,
  faFilter,
  faLock,
  faPhone,
  faPrint,
  faSearch,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { toast } from "react-toastify";
import "./../styles/commande.css";

const commandesMock = [
  {
    id: "CMD-2023-001",
    client: "Roger Wilson",
    statut: "en cours",
    montant: "170,000 FCFA",
    nombreArticles: 3,
    date: "10/02/2023",
    photo: "https://i.pravatar.cc/150?img=5",
    articles: [
      { nom: "Appareil photo Canon", prix: "50,000 FCFA", quantite: 1 },
      { nom: "Laptop Dell Latitude 55", prix: "100,000 FCFA", quantite: 1 },
      { nom: "Écran Sharp Smart", prix: "20,000 FCFA", quantite: 1 },
    ],
    clientDetails: {
      nom: "Roger Wilson",
      email: "roger.wilson@example.com",
      telephone: "+237 67 89 01 23",
      adresse: "Abidjan, Cocody Riviera",
    },
  },

  {
    id: "CMD-2023-002",
    client: "Roger Wilson",
    statut: "en cours",
    montant: "170,000 FCFA",
    nombreArticles: 3,
    date: "10/02/2023",
    photo: "https://i.pravatar.cc/150?img=5",
    articles: [
      { nom: "Appareil photo Canon", prix: "50,000 FCFA", quantite: 1 },
      { nom: "Laptop Dell Latitude 55", prix: "100,000 FCFA", quantite: 1 },
      { nom: "Écran Sharp Smart", prix: "20,000 FCFA", quantite: 1 },
    ],
    clientDetails: {
      nom: "Roger Wilson",
      email: "roger.wilson@example.com",
      telephone: "+225 07 12 34 56 78",
      adresse: "Abidjan, Cocody Riviera",
    },
  },

  // ... autres commandes
];

const MOT_DE_PASSE_ADMIN = "admin123"; // Mot de passe pour les modifications

export default function CommandeDashboard() {
  const [commandes, setCommandes] = useState(commandesMock);
  const [selectedCommande, setSelectedCommande] = useState(commandes[0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("Tous");
  const [dateFilter, setDateFilter] = useState("Tous");
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);

  const getStatutBadge = (statut) => {
    switch (statut) {
      case "en cours":
        return { class: "bg-warning text-dark", icon: faClock };
      case "livrée":
        return { class: "bg-success", icon: faCheckCircle };
      case "annulée":
        return { class: "bg-danger", icon: faTimesCircle };
      default:
        return { class: "bg-secondary", icon: faClock };
    }
  };

  const filteredCommandes = commandes.filter((cmd) => {
    const matchesSearch =
      cmd.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
      cmd.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus =
      statusFilter === "Tous" || cmd.statut === statusFilter;
    const matchesDate = dateFilter === "Tous" || cmd.date.includes(dateFilter);

    return matchesSearch && matchesStatus && matchesDate;
  });

  const calculateTotal = (articles) => {
    return (
      articles
        .reduce((total, article) => {
          const prix = parseInt(article.prix.replace(/\D/g, ""));
          return total + prix * article.quantite;
        }, 0)
        .toLocaleString("fr-FR") + " FCFA"
    );
  };

  const handleModifierStatut = (statut) => {
    setNewStatus(statut);
    setShowPasswordModal(true);
  };

  const confirmStatusChange = () => {
    if (password === MOT_DE_PASSE_ADMIN) {
      setCommandes(
        commandes.map((cmd) =>
          cmd.id === selectedCommande.id ? { ...cmd, statut: newStatus } : cmd
        )
      );
      setSelectedCommande({ ...selectedCommande, statut: newStatus });
      setShowPasswordModal(false);
      setPassword("");
      setPasswordError(false);
      toast.success(
        `Statut de la commande ${selectedCommande.id} modifié en "${newStatus}"`
      );
    } else {
      setPasswordError(true);
      toast.error("Mot de passe incorrect. Veuillez réessayer.");
    }
  };

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-0">Gestion des Commandes</h4>
          <small className="text-muted">
            {filteredCommandes.length} commande(s) trouvée(s)
          </small>
        </div>
      </div>

      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <FontAwesomeIcon icon={faSearch} />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Rechercher par client ou ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <select
                  className="form-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="Tous">Tous les statuts</option>
                  <option value="en cours">En cours</option>
                  <option value="livrée">Livrée</option>
                  <option value="annulée">Annulée</option>
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <select
                  className="form-select"
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                >
                  <option value="Tous">Toutes les dates</option>
                  <option value="2023">2023</option>
                  <option value="02">Février</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <div className="card shadow-sm">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Commande</th>
                      <th>Client</th>
                      <th>Statut</th>
                      <th>Montant</th>
                      <th>Articles</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCommandes.map((cmd) => (
                      <tr
                        key={cmd.id}
                        onClick={() => setSelectedCommande(cmd)}
                        className={
                          selectedCommande?.id === cmd.id ? "table-primary" : ""
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <td className="fw-bold">{cmd.id}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <img
                              src={cmd.photo}
                              alt={cmd.client}
                              className="rounded-circle me-2"
                              width="32"
                              height="32"
                            />
                            {cmd.client}
                          </div>
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              getStatutBadge(cmd.statut).class
                            }`}
                          >
                            <FontAwesomeIcon
                              icon={getStatutBadge(cmd.statut).icon}
                              className="me-1"
                            />
                            {cmd.statut}
                          </span>
                        </td>
                        <td>{cmd.montant}</td>
                        <td>{cmd.nombreArticles}</td>
                        <td>
                          <div className="dropdown">
                            <button
                              className="btn btn-sm btn-outline-secondary dropdown-toggle "
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenMenuId(
                                  openMenuId === cmd.id ? null : cmd.id
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faEllipsisVertical} />
                            </button>

                            {openMenuId === cmd.id && (
                              <div
                                className="dropdown-menu show"
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  left: "auto",
                                }}
                              >
                                <button
                                  className="dropdown-item"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleModifierStatut("en cours");
                                    setOpenMenuId(null);
                                  }}
                                  disabled={cmd.statut === "en cours"}
                                >
                                  <FontAwesomeIcon
                                    icon={faClock}
                                    className="me-2"
                                  />
                                  Marquer "En cours"
                                </button>
                                <button
                                  className="dropdown-item"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleModifierStatut("livrée");
                                    setOpenMenuId(null);
                                  }}
                                  disabled={cmd.statut === "livrée"}
                                >
                                  <FontAwesomeIcon
                                    icon={faCheckCircle}
                                    className="me-2"
                                  />
                                  Marquer "Livrée"
                                </button>
                                <button
                                  className="dropdown-item"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleModifierStatut("annulée");
                                    setOpenMenuId(null);
                                  }}
                                  disabled={cmd.statut === "annulée"}
                                >
                                  <FontAwesomeIcon
                                    icon={faTimesCircle}
                                    className="me-2"
                                  />
                                  Marquer "Annulée"
                                </button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          {selectedCommande && (
            <div className="card shadow-sm h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Détails de la commande</h5>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">Commande #{selectedCommande.id}</h6>
                  <span
                    className={`badge ${
                      getStatutBadge(selectedCommande.statut).class
                    }`}
                  >
                    {selectedCommande.statut}
                  </span>
                </div>
                <small className="text-muted">
                  Date: {selectedCommande.date}
                </small>

                <div className="my-4">
                  <h6>Client</h6>
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src={selectedCommande.photo}
                      className="rounded-circle me-3"
                      alt={selectedCommande.client}
                      width="64"
                      height="64"
                    />
                    <div>
                      <h5 className="mb-1">
                        {selectedCommande.clientDetails.nom}
                      </h5>
                      <div className="d-flex gap-3">
                        <a
                          href={`tel:${selectedCommande.clientDetails.telephone}`}
                          className="text-decoration-none"
                        >
                          <FontAwesomeIcon
                            icon={faPhone}
                            className="me-1 text-primary"
                          />
                        </a>
                        <a
                          href={`mailto:${selectedCommande.clientDetails.email}`}
                          className="text-decoration-none"
                        >
                          <FontAwesomeIcon
                            icon={faEnvelope}
                            className="me-1 text-primary"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <p className="small text-muted mb-0">
                    {selectedCommande.clientDetails.adresse}
                  </p>
                </div>

                <div className="mb-4">
                  <h6>Articles commandés</h6>
                  <div className="list-group">
                    {selectedCommande.articles.map((article, index) => (
                      <div
                        key={index}
                        className="list-group-item border-0 px-0 py-2"
                      >
                        <div className="d-flex justify-content-between">
                          <div>
                            <strong>{article.nom}</strong>
                            <div className="small text-muted">
                              Quantité: {article.quantite}
                            </div>
                          </div>
                          <div className="text-primary">{article.prix}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="border-top pt-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Sous-total:</span>
                    <span>{calculateTotal(selectedCommande.articles)}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Livraison:</span>
                    <span>5,000 FCFA</span>
                  </div>
                  <div className="d-flex justify-content-between fw-bold">
                    <span>Total:</span>
                    <span>{selectedCommande.montant}</span>
                  </div>
                </div>

                <div className="d-grid gap-2 mt-4">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => handleModifierStatut("en cours")}
                    disabled={selectedCommande.statut === "en cours"}
                  >
                    <FontAwesomeIcon icon={faClock} className="me-2" />
                    Marquer "En cours"
                  </button>
                  <button
                    className="btn btn-outline-success"
                    onClick={() => handleModifierStatut("livrée")}
                    disabled={selectedCommande.statut === "livrée"}
                  >
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    Marquer "Livrée"
                  </button>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => handleModifierStatut("annulée")}
                    disabled={selectedCommande.statut === "annulée"}
                  >
                    <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                    Marquer "Annulée"
                  </button>
                  <button className="btn btn-outline-secondary">
                    <FontAwesomeIcon icon={faPrint} className="me-2" />
                    Imprimer
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal de confirmation avec mot de passe */}
      {showPasswordModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Confirmation requise</h5>
              <button
                className="btn-close"
                onClick={() => {
                  setShowPasswordModal(false);
                  setPassword("");
                  setPasswordError(false);
                }}
              >
                <FontAwesomeIcon icon={faTimesCircle} />
              </button>
            </div>
            <div className="modal-body">
              <p>
                Vous êtes sur le point de modifier le statut de la commande en :{" "}
                <span className={`badge ${getStatutBadge(newStatus).class}`}>
                  {newStatus}
                </span>
              </p>
              <p>
                Veuillez saisir le mot de passe administrateur pour confirmer :
              </p>

              <div className="mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon={faLock} />
                  </span>
                  <input
                    type="password"
                    className={`form-control ${
                      passwordError ? "is-invalid" : ""
                    }`}
                    placeholder="Mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                {passwordError && (
                  <div className="invalid-feedback d-block">
                    Mot de passe incorrect
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowPasswordModal(false);
                  setPassword("");
                  setPasswordError(false);
                }}
              >
                Annuler
              </button>
              <button className="btn btn-primary" onClick={confirmStatusChange}>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
